import React from 'react';
import { RotateCcw } from 'lucide-react';
import type { Checklist } from '../../hooks/useChecklist';

/** Aviso de lista personal + botón para reiniciar el progreso manual. */
export function ChecklistBar({
  list,
  total,
  done
}: {
  list: Checklist;
  total: number;
  done: number;
}) {
  return <div className="flex flex-col gap-3 rounded-2xl border border-dashed border-white/15 p-3.5 sm:flex-row sm:items-center sm:justify-between" data-id="element-736" data-mp="2ewr9925zq1sz">
      <div className="min-w-0" data-id="element-737" data-mp="2iy33xm3q1d81">
        <p className="text-sm font-semibold text-white" data-id="element-738" data-mp="2iwry7gqptvea">
          Tu progreso: {done} de {total}
        </p>
        <p className="mt-0.5 text-xs text-gray-400" data-id="element-739" data-mp="2sopeh1wkzdjv">Lista personal guardada en este navegador. No consulta tu inventario ni el estado real de tus misiones.</p>
      </div>
      <button type="button" onClick={list.reset} disabled={done === 0} className="inline-flex h-10 shrink-0 items-center justify-center gap-2 rounded-full border border-white/15 px-4 text-sm font-semibold text-gray-200 transition-colors duration-150 hover:border-[#D4AF37]/50 hover:text-white disabled:opacity-40" data-id="element-740" data-mp="2xplgtb1aarn6">
        <RotateCcw className="h-4 w-4" aria-hidden="true" data-id="element-741" data-mp="37kf6kbs8877c" />
        Reiniciar
      </button>
    </div>;
}

/** Casilla accesible "Ya lo tengo" / "Completado". */
export function CheckBox({
  checked,
  onChange,
  label
}: {
  checked: boolean;
  onChange: () => void;
  label: string;
}) {
  return <label className="flex min-h-[40px] cursor-pointer items-center gap-2 text-xs font-semibold text-gray-300" data-id="element-742" data-mp="3vasupr7oxlwn">
      <input type="checkbox" checked={checked} onChange={onChange} className="h-5 w-5 shrink-0 rounded accent-[#D4AF37]" data-id="element-743" data-mp="3qc7pfddl0c1c" />
      <span className={checked ? 'text-[#D4AF37]' : ''} data-id="element-744" data-mp="3livfm9dka9sn">{label}</span>
    </label>;
}